import script from "./ClientesContrato.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientesContrato.vue?vue&type=script&lang=ts&setup=true"

import "./ClientesContrato.vue?vue&type=style&index=0&id=ac452864&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac452864"]])

export default __exports__